import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Login from '@/components/Login'
import Factura from '@/components/Factura'
import Facturaadd from '@/components/Facturaadd'
import Cliente from '@/components/Cliente'
import Reporte from '@/components/Reporte'
import ReporteVentas from '@/components/ReporteVentas'
import Kilometraje from '@/components/Kilometraje'
import Kilometrajevendedor from '@/components/KilometrajeVendedor'
import AnularFacturas from '@/components/AnularFacturas'
import Cotizacion from '@/components/Cotizacion'
import Cotizacionadd from '@/components/Cotizacionadd'
import Buscador from '@/components/Buscador'
import Extraccion from '@/components/Extraccion'
import Extraccionadd from '@/components/extraccionadd'
import Cuadrar from '@/components/Cuadrar'
import AnularFactura from '@/components/AnularFactura'
import CompraTemporal from '@/components/CompraTemporal'
import ComprasAdd from '@/components/ComprasAdd'
import ReporteDevolucion from '@/components/ReporteDevolucion'
import ActualizaUbicacionCliente from '@/components/ActualizaUbicacionCliente'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      props: {
        numero: {
          type: Number
        },
        serie: {
          type: String
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/comprasadd',
      name: 'CompraAdd',
      component: ComprasAdd
    },
    {
      path: '/compratemporal',
      name: 'CompraTemporal',
      component: CompraTemporal
    },
    {
      path: '/factura',
      name: 'Factura',
      component: Factura
    },
    {
      path: '/facturaadd',
      name: 'Facturaadd',
      component: Facturaadd
    },
    {
      path: '/cotizacionadd',
      name: 'Cotizacionadd',
      component: Cotizacionadd
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: Cliente
    },
    {
      path: '/buscador',
      name: 'Buscador',
      component: Buscador
    },
    {
      path: '/reportes',
      name: 'Reportes',
      component: Reporte
    },
    {
      path: '/reporteventas',
      name: 'ReporteVentas',
      component: ReporteVentas
    },
    {
      path: '/kilometraje',
      name: 'Kilometraje',
      component: Kilometraje
    },
    {
      path: '/kilometrajevendedor',
      name: 'Kilometraje Vendedor',
      component: Kilometrajevendedor
    },
    {
      path: '/anularfacturas',
      name: 'AnularFacturas',
      component: AnularFacturas
    },
    {
      path: '/cotizacion',
      name: 'Cotizacion',
      component: Cotizacion
    },
    {
      path: '/extraccion',
      name: 'Extraccion',
      component: Extraccion
    },
    {
      path: '/extraccionadd',
      name: 'Extraccionadd',
      component: Extraccionadd
    },
    {
      path: '/cuadrar',
      name: 'cuadrar',
      component: Cuadrar
    },
    {
      path: '/anularfactura',
      name: 'anularfactura',
      component: AnularFactura
    },
    {
      path: '/devoluciones',
      name: 'reporte devolucion',
      component: ReporteDevolucion
    },
    {
      path: '/clientes/ubicacion/:id',
      name: 'Actualiza Cliente Ubicacion',
      component: ActualizaUbicacionCliente
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js